module.exports = __webpack_public_path__ + "img/Shanghai-power.fa126004.png";